import React from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { round2, getInterventionTotals, calculateVatGroups } from "../../../../../../../util/common";

const TotalAmount = ({ communication, keylocker, t }) => {
  const { include_vat, vat } = keylocker;
  const { interventions } = communication.appointment;
  const { check_in_results: optional_services } = communication;

  const interventionTotals = getInterventionTotals(interventions, keylocker);

  let servicesTotal = 0;
  let additionalPrices = 0;

  const vatRate = include_vat ? 1 + vat / 100 : 1;

  if (Array.isArray(optional_services)) {
    servicesTotal = optional_services.reduce((prev, cur) => {
      if (cur.accepted && cur.price > 0.01) {
        prev += round2(cur.price * vatRate);
        additionalPrices += cur.price;
      }
      return prev;
    }, 0);
  }

  const totalAmount = round2(interventionTotals.totalAmount + servicesTotal);
  if (!totalAmount) return null;

  const allVatGroups = calculateVatGroups(interventionTotals.vatGroups, additionalPrices, keylocker);
  const vatGroups = allVatGroups.filter(group => group.rate > 0 && group.amount > 0);

  return (
    <Grid className="OrderContainer TotalAmount">
      {include_vat &&
        allVatGroups.length > 1 &&
        vatGroups.map(group => (
          <Grid.Row key={"total-" + group.rate}>
            <Grid.Column width={14}>
              <span className="vat-name">
                {t("cc_total_with").message || "Total with"} {group.rate}% {t("cc_vat").message || "VAT"}
              </span>
            </Grid.Column>
            <Grid.Column width={2}>
              <span className="price">€ {group.total.toFixed(2)}</span>
            </Grid.Column>
          </Grid.Row>
        ))}
      <Grid.Row>
        <Grid.Column width={14}>
          <span className="name">{t("cc_TOTAL_AMOUNT").message || "TOTAL AMOUNT"}:</span>
        </Grid.Column>

        <Grid.Column width={2}>
          <span className="price">€ {totalAmount.toFixed(2)}</span>
        </Grid.Column>
      </Grid.Row>
      {include_vat &&
        vatGroups.map(group => (
          <Grid.Row key={group.rate}>
            <Grid.Column width={14}>
              <span className="vat-name">
                *{t("cc_including").message || "Including"} {group.rate}% {t("cc_vat").message || "VAT"}
              </span>
            </Grid.Column>

            <Grid.Column width={2}>
              <span className="price">€ {group.amount.toFixed(2)}</span>
            </Grid.Column>
          </Grid.Row>
        ))}
    </Grid>
  );
};

export default withTranslation()(TotalAmount);
